import React, {useMemo} from 'react';
import {FormGroup, InputGroup} from '@blueprintjs/core';
import debounce from 'lodash/debounce';

interface KeyProps {
  defaultValue: string;
  onChange: (value: any) => void;
  disabled: boolean;
}

export const Key = ({
  defaultValue,
  onChange,
  disabled,
}: KeyProps) => {
  const debounceOnChange = useMemo(() => debounce(onChange, 400), [onChange]);
  const onInputChange = (event: any) => {
    const value = event.target.value;
    debounceOnChange(value);
  }

  return (
    <>
      <br/>
      <FormGroup label="File path" labelFor="key">
        <InputGroup
          id="key"
          defaultValue={defaultValue}
          onChange={onInputChange}
          fill={true}
          disabled={disabled}
        />
      </FormGroup>
    </>
  );
}

export default Key;
